import React from 'react';
import '../styles/Legal.css';
import usePageMeta from "../hooks/usePageMeta";

const LAST_UPDATED = 'January 9, 2026';

const SubprocessorsPage: React.FC = () => {
  usePageMeta({
    title: "Subprocessors | PabSync",
    description:
      "Third-party service providers that help us operate PabSync.",
    path: "/subprocessors",
  });

  return (
    <div className="legal-page">
      <main className="legal-container">
        <article className="legal-card">
          <h1 className="legal-title">Subprocessors</h1>
          <p className="legal-meta">Last updated: {LAST_UPDATED}</p>

          <p>
            Subprocessors are third-party service providers that may process limited information on our behalf to help us
            operate PabSync.
          </p>

          <h2>Common categories</h2>
          <ul>
            <li><strong>Hosting / infrastructure</strong> (compute, storage, networking).</li>
            <li><strong>Email delivery</strong> (transactional and operational messages).</li>
            <li><strong>Payments</strong> (subscription billing and payment processing).</li>
            <li><strong>Security</strong> (abuse prevention such as reCAPTCHA).</li>
          </ul>

          <h2>Examples (may vary by environment)</h2>
          <ul>
            <li>Google reCAPTCHA (security / abuse prevention)</li>
            <li>PayPal (billing and payments)</li>
          </ul>

          <p className="legal-note">
            The specific vendors we use can change over time as we improve the service.
          </p>

          <h2>Related pages</h2>
          <p>
            See our <a href="/privacy">Privacy Statement</a> and <a href="/cookies">Cookies Notice</a>.
          </p>
        </article>
      </main>
    </div>
  );
};

export default SubprocessorsPage;
